import {createFileRoute, Outlet} from '@tanstack/react-router';

import {ImagesCacheProvider} from 'src/contexts/ImagesCacheProvider';

export const Route = createFileRoute('/model/finetune')({
  component: ModelFinetuneLayout,
});

function ModelFinetuneLayout() {
  return (
    <ImagesCacheProvider mode='model-finetune'>
      <Outlet />
    </ImagesCacheProvider>
  );
}
